// extracted by mini-css-extract-plugin
export default {"tosInfo":"Si6zlKDhu2EjnBCp1oxq"};